export default __webpack_public_path__ + "static/media/step-1-en.370cb230.png";